
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter2 as ObiFilter2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-2.js';
 
 
 

 
 export const ObiFilter2 = createComponent({
   react: React,
   tagName: 'obi-filter-2',
   elementClass: ObiFilter2Element,
   events: {
     
   }
  });
 
 